import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBybitCardBonus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .009.06c.049.378.36.668.742.69l-.029.005a.894.894 0 0 0-.721.745.834.834 0 0 0-.682-.738l-.068-.012a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M3.75 5.25a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h.75v1.5a1.5 1.5 0 0 0 1.5 1.5h13.5A2.25 2.25 0 0 0 21.75 18V9.75a1.5 1.5 0 0 0-1.5-1.5h-1.5v-1.5a1.5 1.5 0 0 0-1.5-1.5H3.75Zm15 4.5v6a1.5 1.5 0 0 1-1.5 1.5H6v1.5h13.5a.75.75 0 0 0 .75-.75V9.75h-1.5Zm-15-3h13.5v9H3.75v-9Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M17.25 10.5H3.75V9h13.5v1.5ZM12 13.5a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-2.25a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBybitCardBonus;
